export default "__VITE_ASSET__OSoDmGkb__"